var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { AxiosError } from "axios";
import { errorMessage } from "@helpers";
import Stripe from 'stripe';
export var useClients = function (key) {
    var stripe = new Stripe(key, {
        apiVersion: '2023-08-16',
    });
    var _a = useState([]), clients = _a[0], setClients = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState({}), client = _c[0], setClient = _c[1];
    var _d = useState(false), hasNextMore = _d[0], setHasNextMore = _d[1];
    var _e = useState(false), hasLessMore = _e[0], setHasLessMore = _e[1];
    var _f = useState(true), nextDisabled = _f[0], setNextDisabled = _f[1];
    var _g = useState(false), isPageChanged = _g[0], setIsPageChanged = _g[1];
    var paginate = function (type) {
        var starting_after = '';
        var ending_before = '';
        if (type === 'prev') {
            ending_before = clients[0].id;
        }
        if (type === 'next') {
            starting_after = clients[clients.length - 1].id;
        }
        void getClients(__assign(__assign({ type: 'list' }, __assign({}, starting_after && { starting_after: starting_after })), __assign({}, ending_before && { ending_before: ending_before })));
    };
    var getClients = function (_a) {
        var _b = _a.type, type = _b === void 0 ? 'list' : _b, query = _a.query, starting_after = _a.starting_after, ending_before = _a.ending_before, _c = _a.id, id = _c === void 0 ? null : _c;
        return __awaiter(void 0, void 0, void 0, function () {
            var client_1, response, response, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setLoading(true);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 8, , 9]);
                        if (!(type === 'retrieve' && id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, stripe.customers.retrieve(id)];
                    case 2:
                        client_1 = _d.sent();
                        // @ts-ignore
                        setClient(client_1);
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(type === 'search' && query)) return [3 /*break*/, 5];
                        return [4 /*yield*/, stripe.customers.search(__assign(__assign({ limit: 10, query: query }, __assign({}, ending_before && { ending_before: ending_before })), __assign({}, starting_after && { starting_after: starting_after })))];
                    case 4:
                        response = _d.sent();
                        setClients(response.data);
                        setNextDisabled(!response.has_more);
                        if (ending_before || starting_after) {
                            setIsPageChanged(true);
                            if (starting_after) {
                                setHasNextMore(response.has_more);
                                setHasLessMore(true);
                            }
                            if (ending_before) {
                                setHasLessMore(response.has_more);
                            }
                        }
                        else {
                            setHasNextMore(response.has_more);
                        }
                        _d.label = 5;
                    case 5:
                        if (!(type === 'list')) return [3 /*break*/, 7];
                        return [4 /*yield*/, stripe.customers.list(__assign(__assign({ limit: 10 }, __assign({}, ending_before && { ending_before: ending_before })), __assign({}, starting_after && { starting_after: starting_after })))];
                    case 6:
                        response = _d.sent();
                        // @ts-ignore
                        setClients(response.data);
                        setNextDisabled(!response.has_more);
                        if (ending_before || starting_after) {
                            setIsPageChanged(true);
                            if (starting_after) {
                                setHasNextMore(response.has_more);
                                setHasLessMore(true);
                            }
                            if (ending_before) {
                                setHasLessMore(response.has_more);
                            }
                        }
                        else {
                            setHasNextMore(response.has_more);
                        }
                        _d.label = 7;
                    case 7:
                        setLoading(false);
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _d.sent();
                        if (error_1 instanceof AxiosError) {
                            errorMessage(error_1);
                        }
                        else {
                            console.error('Clients fetch error ', error_1);
                        }
                        setLoading(false);
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return {
        clients: clients,
        client: client,
        hasLessMore: hasLessMore,
        hasNextMore: hasNextMore,
        isPageChanged: isPageChanged,
        loading: loading,
        setIsPageChanged: setIsPageChanged,
        paginate: paginate,
        getClients: getClients
    };
};
